import { ILibraryTopology } from '@wix/editor-elements-registry'

export interface IComponentsRegistrySiteConfig {
	librariesTopology: Array<ILibraryTopology>
}

export const name = 'componentsRegistry'
